import React from "react";
import Modal from "components/BaseWidgets/modal";
import Avatar from "components/BaseWidgets/Avatar";

function ProfileCreatedModal({
  open,
  onCancel,
  closeIcon,
  className,
  wrapClassName,
  width,
  title,
  aec_id,
  src,
}) {
  return (
    <Modal
      isOpen={open}
      className={`profile-created-modal ${className || ""}`}
      onCancel={onCancel}
      title=""
      width={width}
      footer={null}
      closable
      closeIcon={closeIcon}
      wrapClassName={wrapClassName}
    >
      <div className="modal-content">
        <span className="avatar-wrapper">
          <Avatar url={src} size={158} />
        </span>
        <div className="heading-frame flex flex-col">
          <span className="content-title font-title-xl">{title}</span>
          <p className="content-description font-title-sm">AEC ID: {aec_id}</p>
        </div>
      </div>
    </Modal>
  );
}

export default ProfileCreatedModal;
